import { updateFeed } from "@/mocks/home";

const quickEntries = [
  { id: "latest", label: "最新地址", icon: "ri-link-m", href: "#entry" },
  { id: "main", label: "官网入口", icon: "ri-global-line", href: "#entry" },
  { id: "app", label: "App下载", icon: "ri-smartphone-line", href: "#collections" },
];

export default function UpdateTicker() {
  const latest = updateFeed[0];

  return (
    <div className="bg-primary-500 text-background-50">
      <div className="flex flex-wrap items-center gap-x-5 gap-y-2 px-4 py-2.5 text-xs md:px-6 md:text-sm">
        <span className="inline-flex items-center gap-2 whitespace-nowrap font-medium">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50/70" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50" />
          </span>
          更新条 · 最新地址已同步
        </span>
        <span className="hidden text-background-50/50 sm:inline">|</span>
        <span className="min-w-[160px] flex-1 truncate text-background-50/90">
          {latest.time}　{latest.title}
        </span>
        <div className="flex flex-wrap items-center gap-2">
          {quickEntries.map((q) => (
            <a
              key={q.id}
              href={q.href}
              className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full bg-background-50/15 px-3 py-1 text-xs text-background-50 transition-colors hover:bg-background-50/25"
            >
              <i className={q.icon} />
              {q.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}